import { render, staticRenderFns } from "./DispensingTableProducts.vue?vue&type=template&id=668077e4&scoped=true"
import script from "./DispensingTableProducts.vue?vue&type=script&lang=js"
export * from "./DispensingTableProducts.vue?vue&type=script&lang=js"
import style0 from "./DispensingTableProducts.vue?vue&type=style&index=0&id=668077e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668077e4",
  null
  
)

export default component.exports